var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 201,
    viewBox: "0 0 88 201",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-112.667 125.625C-126.52 125.625 -137.75 114.376 -137.75 100.5C-137.75 86.6238 -126.52 75.375 -112.667 75.375L-12.3333 75.375C1.51981 75.375 12.75 86.6238 12.75 100.5C12.75 114.376 1.51981 125.625 -12.3333 125.625L-112.667 125.625ZM-112.667 80.4L-12.3333 80.4C-1.25082 80.4 7.73334 89.3991 7.73334 100.5C7.73334 111.601 -1.25082 120.6 -12.3333 120.6L-112.667 120.6C-123.749 120.6 -132.733 111.601 -132.733 100.5C-132.733 89.3991 -123.749 80.4 -112.667 80.4Z",
    fill: "url(#paint0_radial_380_630)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-152.8 100.5C-152.8 122.702 -134.832 140.7 -112.667 140.7H-12.3333C9.83171 140.7 27.8 122.702 27.8 100.5C27.8 78.2981 9.83171 60.3 -12.3333 60.3H-112.667C-134.832 60.3 -152.8 78.2981 -152.8 100.5ZM-12.3333 65.325H-112.667C-132.061 65.325 -147.783 81.0734 -147.783 100.5C-147.783 119.927 -132.061 135.675 -112.667 135.675H-12.3333C7.06108 135.675 22.7833 119.927 22.7833 100.5C22.7833 81.0734 7.06108 65.325 -12.3333 65.325Z",
    fill: "url(#paint1_radial_380_630)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-112.667 155.775C-143.144 155.775 -167.85 131.028 -167.85 100.5C-167.85 69.9725 -143.144 45.225 -112.667 45.225H-12.3333C18.1436 45.225 42.85 69.9725 42.85 100.5C42.85 131.028 18.1436 155.775 -12.3333 155.775H-112.667ZM-112.667 50.25H-12.3333C15.373 50.25 37.8333 72.7477 37.8333 100.5C37.8333 128.252 15.373 150.75 -12.3333 150.75H-112.667C-140.373 150.75 -162.833 128.252 -162.833 100.5C-162.833 72.7477 -140.373 50.25 -112.667 50.25Z",
    fill: "url(#paint2_radial_380_630)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-182.9 100.5C-182.9 139.353 -151.455 170.85 -112.667 170.85H-12.3333C26.4555 170.85 57.9 139.353 57.9 100.5C57.9 61.6468 26.4555 30.15 -12.3333 30.15H-112.667C-151.455 30.15 -182.9 61.6468 -182.9 100.5ZM-12.3333 35.175H-112.667C-148.685 35.175 -177.883 64.422 -177.883 100.5C-177.883 136.578 -148.685 165.825 -112.667 165.825H-12.3333C23.6849 165.825 52.8833 136.578 52.8833 100.5C52.8833 64.422 23.6848 35.175 -12.3333 35.175Z",
    fill: "url(#paint3_radial_380_630)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-112.667 185.925C-159.767 185.925 -197.95 147.679 -197.95 100.5C-197.95 53.3211 -159.767 15.075 -112.667 15.075H-12.3333C34.7674 15.075 72.95 53.3211 72.95 100.5C72.95 147.679 34.7674 185.925 -12.3333 185.925H-112.667ZM-112.667 20.1H-12.3333C31.9967 20.1 67.9333 56.0963 67.9333 100.5C67.9333 144.904 31.9967 180.9 -12.3333 180.9H-112.667C-156.997 180.9 -192.933 144.904 -192.933 100.5C-192.933 56.0963 -156.997 20.1 -112.667 20.1Z",
    fill: "url(#paint4_radial_380_630)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-112.667 201C-168.079 201 -213 156.005 -213 100.5C-213 44.9954 -168.079 0 -112.667 0H-12.3333C43.0793 0 88 44.9954 88 100.5C88 156.005 43.0792 201 -12.3333 201H-112.667ZM-112.667 5.02499H-12.3333C40.3086 5.02499 82.9833 47.7706 82.9833 100.5C82.9833 153.229 40.3086 195.975 -12.3333 195.975H-112.667C-165.309 195.975 -207.983 153.229 -207.983 100.5C-207.983 47.7706 -165.309 5.02499 -112.667 5.02499Z",
    fill: "url(#paint5_radial_380_630)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_380_630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.5 100.5) rotate(-11.3282) scale(204.654 136.645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_380_630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.5 100.5) rotate(-11.3282) scale(204.654 136.645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_380_630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.5 100.5) rotate(-11.3282) scale(204.654 136.645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_380_630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.5 100.5) rotate(-11.3282) scale(204.654 136.645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_380_630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.5 100.5) rotate(-11.3282) scale(204.654 136.645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_380_630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.5 100.5) rotate(-11.3282) scale(204.654 136.645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.028849ed8b791eef93f220f8ac0db13c.svg";
export { ForwardRef as ReactComponent };